<template>
  <div
    layout="row"
    layout-align="start center"
    @keyup.capture="updateValue"
    style="width: fit-content"
  >
    <v-text-field
      v-if="showDay"
      ref="day"
      v-model="day"
      style="width: 3em; max-width: 3em"
      @keypress="isNumber($event)"
      :name="'day_field'+name"
      :placeholder="$t('_.dd')"
      maxlength="2"
      @input="updateDay"
      @blur="day ? (day = day.padStart(2, 0)) : ''"
    >
    </v-text-field>
    <span
      v-if="showDay && showMonth"
      class="date_divider mx-2"
    >/</span>
    <v-text-field
      v-if="showMonth"
      ref="month"
      v-model="month"
      style="width: 3em; max-width: 3em"
      @keypress="isNumber($event)"
      :name="'month_field'+name"
      :placeholder="$t('_.mm')"
      maxlength="2"
      @input="updateMonth"
      @blur="month ? (month = month.padStart(2, 0)) : ''"
    >
    </v-text-field>
    <span
      v-if="showYear && (showDay || showMonth)"
      class="date_divider mx-2"
    >/</span>
    <v-text-field
      v-if="showYear"
      ref="year"
      v-model="year"
      style="width: 4em; max-width: 4em"
      @keypress="isNumber($event)"
      :placeholder="$t('_.yyyy')"
      maxlength="4"
      @blur="year ? (year = year.padStart(4, 0)) : ''"
    >
    </v-text-field>

    <v-menu
      :ref="'menu_'+name"
      :close-on-content-click="false"
      v-model="datepicker"
      :nudge-right="40"
      lazy
      transition="scale-transition"
      offset-y
      full-width
      class="ml-1"
    >
      <v-icon
        slot="activator"
        color="secondary"
      >mdi-calendar</v-icon>
      <v-date-picker
        v-model="pickerValue"
        no-title
        @input="onDatePicked"
        :first-day-of-week="1"
        :locale="_locale"
      />
    </v-menu>
  </div>
</template>

<script>
import moment from 'moment'
import I18nMixin from '@/mixins/i18n'

export default {
  name: `DateField`,
  props: {
    value: {
      type: [Number, String],
      required: true,
    },
    showDay: {
      type: Boolean,
      default: true,
    },
    showMonth: {
      type: Boolean,
      default: true,
    },
    showYear: {
      type: Boolean,
      default: true,
    },
    name: {
      type: String,
      default: 'key'
    }
  },
  mixins: [I18nMixin],
  data () {
    return {
      day: `${this.value ? ("0" + new Date(this.value).getDate()).slice(-2) : ``}`,
      month: `${this.value ? ("0" + (new Date(this.value).getMonth() + 1)).slice(-2) : ``}`,
      year: `${this.value ? new Date(this.value).getFullYear() : ``}`,
      datepicker: false,
      initied: false
    }
  },
  computed: {
    pickerValue: {
      get () {
        return this.value
      },
      set (x) {
        this.$emit('input', x)
      }
    },
  },
  watch: {
    year (current, prev) {
      if (current > 9999) this.year = prev
    },
    value (val) {
      if (!this.initied && val) {
        this.day = `${this.value ? ('0' + new Date(this.value).getDate()).slice(-2) : ''}`
        this.month = `${this.value ? ('0' + (new Date(this.value).getMonth() + 1)).slice(-2) : ''}`
        this.year = `${this.value ? new Date(this.value).getFullYear() : ''}`
        this.initied = true
      }
    }
  },
  methods: {
    updateDay () {
      let dayField = document.getElementsByName('day_field' + this.name)[0]
      if (!this.day || !this.day.length || dayField.selectionStart < 2) return
      if (this.showMonth) this.$refs.month.focus()
      else if (this.showYear) this.$refs.year.focus()
    },
    updateMonth () {
      let monthField = document.getElementsByName('month_field' + this.name)[0]
      if (!this.month || !this.month.length || monthField.selectionStart < 2) return
      if (this.showYear) this.$refs.year.focus()
    },
    updateValue () {
      if (!this.year || !this.month || !this.day || this.year.length != 4 || this.month.length != 2 || this.day.length != 2) return
      this.$emit(`input`, moment(this.year + '-' + this.month + '-' + this.day).format('YYYY-MM-DD'))
    },
    isNumber (evt) {
      evt = (evt) ? evt : window.event
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if (charCode > 47 && charCode < 58) {
        return true
      } else {
        evt.preventDefault()
      }
    },
    parseDate (date) {
      if (!date) return null

      if (date.indexOf('-') >= 0) {
        return date
      }

      return moment(date, 'DD/MM/YYYY').format('YYYY-MM-DD')
    },
    onDatePicked (val) {
      this.datepicker = false
      let date = this.parseDate(val)
      this.day = ("0" + new Date(date).getDate()).slice(-2)
      this.month = ("0" + (new Date(date).getMonth() + 1)).slice(-2)
      this.year = new Date(date).getFullYear().toString()
      this.updateDay()
    }
  },
};
</script>
<style>
.date_divider {
  padding-top: 0.75em;
  padding-bottom: 0.75em;
  pointer-events: none;
}
</style>
